import { useEffect, useRef } from 'react';
import { useWebSocket } from '../context/WebSocketContext';

/**
 * Suscribe al evento sites.notification.created del WebSocket compartido.
 * Usa la única conexión del WebSocketContext (no abre una nueva).
 */
export function useNotificationsWebSocket(onNewNotification) {
  const { connected, healthy, subscribe } = useWebSocket();
  const onNewNotificationRef = useRef(onNewNotification);
  onNewNotificationRef.current = onNewNotification;

  useEffect(() => {
    const unsubscribe = subscribe('sites.notification.created', (data) => {
      const cb = onNewNotificationRef.current;
      if (typeof cb === 'function') cb(data);
    });
    return unsubscribe;
  }, [subscribe]);

  return { connected, healthy };
}
